import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';

import {
  CLEAR_COMPONENT_API_RESPONSE,
  COMPONENT_MODIFIED,
  COMPONENT_SAVE_REJECTED,
  COMPONENT_SAVE_FULFILLED,
  UNPUBLISH_COMPONENT_FULFILLED,
  UNPUBLISH_COMPONENT_REJECTED
} from 'app/EditorPane/const';
import {
  CREATE_UNSAVED_PAGE,
  DUPLICATE_PAGE,
  GET_PAGE_SUCCESS,
  REMOVE_ACTIVE_PAGE,
  REMOVE_COMPONENT_FROM_PAGE
} from 'app/Page/const';
import { COMPONENT_PUBLISH_REJECTED } from 'app/PublishComponent/const';

import {
  CREATE_COMPONENT_COMPONENT_SELECTED,
  CREATE_DUPLICATE_COMPONENT,
  DELETE_COMPONENT_REJECTED,
  GET_IMAGE_SIZE_FOR_COMPONENT_RESPONSE,
  GET_EXISTING_COMPONENTS_FULLFILLED,
  GET_EXISTING_COMPONENTS_REJECTED,
  OPEN_COMPONENT_FOR_EDITING,
  OPEN_PARENT_COMPONENT_FOR_EDITING
} from './const';

export const defaultState = {
  parentComponentsStack: []
};

/**
 * Reducer for canvas
 * @param {object} state - state object for canvas
 * @param {object} action - dispatched action object
 * @returns {object} new state.object after dispatched performing action
 */
export const componentReducer = function componentReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case CREATE_UNSAVED_PAGE:
    case DUPLICATE_PAGE:
    case GET_PAGE_SUCCESS:
    case REMOVE_ACTIVE_PAGE:
    case REMOVE_COMPONENT_FROM_PAGE:
      return defaultState;
    case GET_EXISTING_COMPONENTS_FULLFILLED: {
      return {
        ...action.component,
        parentComponentsStack: []
      };
    }
    case OPEN_COMPONENT_FOR_EDITING: {
      const parentComponentsStack = [...(state.parentComponentsStack || [])];
      if (action.parentComponent) {
        const { Id, ComponentName } = action.parentComponent;
        parentComponentsStack.push({ Id, ComponentName });
      }
      return {
        ...action.component,
        parentComponentsStack
      };
    }
    case OPEN_PARENT_COMPONENT_FOR_EDITING: {
      if (state.parentComponentsStack.length > 0) {
        const parentComponentsStack = [...state.parentComponentsStack];
        parentComponentsStack.pop();
        return {
          ...action.parentComponent,
          parentComponentsStack
        };
      }
      return state;
    }
    case CREATE_COMPONENT_COMPONENT_SELECTED: {
      if (action.component) {
        return action.component;
      }
      return state;
    }
    case CREATE_DUPLICATE_COMPONENT:
      return action.component;
    case GET_IMAGE_SIZE_FOR_COMPONENT_RESPONSE:
    case COMPONENT_MODIFIED: {
      const component = cloneDeep(state);
      set(component, action.schemaField, action.value);
      return component;
    }
    case COMPONENT_SAVE_REJECTED: {
      const { body } = action.error;
      return {
        ...state,
        apiResponse: body
      };
    }
    case CLEAR_COMPONENT_API_RESPONSE:
      return {
        ...state,
        apiResponse: undefined
      };
    case COMPONENT_SAVE_FULFILLED:
      return {
        ...state,
        Id: action.response.Id || state.Id,
        Version: action.response.Version || state.Version
      };
    case UNPUBLISH_COMPONENT_FULFILLED:
      return {
        ...state,
        Id: action.response.Id || state.Id,
        Version: action.response.Version || state.Version
      };
    case COMPONENT_PUBLISH_REJECTED:
    case DELETE_COMPONENT_REJECTED:
    case GET_EXISTING_COMPONENTS_REJECTED:
    case UNPUBLISH_COMPONENT_REJECTED:
      return state;
    default:
      return state;
  }
};
